import script from "./SupplierForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierForm.vue?vue&type=script&setup=true&lang=js"

import "./SupplierForm.vue?vue&type=style&index=0&id=6a81e6d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a81e6d2"]])

export default __exports__